/* eslint-disable react/no-unescaped-entities */
import { tap } from 'lodash/fp';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContactFooter from './ContactFooter';
import formatAddressForDisplay from './formatAddressForDisplay';
import config from '../../../../helpers/config';
import * as availabilityApi from '../availabilityApi';
import createEstimateConfigurations from '../../../../services/createEstimateConfigurations';
import createMandIEstimate from '../../../../services/createMandIEstimate';
import InfoFullIcon from '../../../../themes/svg/infoFullIcon';

class CoveredByThd extends Component {
  redirectMandI = (e) => {
    e.preventDefault();
    this.props.loading();

    const { measureAndInstallEstimate, itemsWithExtraQuantity } = this.props;

    const configurationsPromise = createEstimateConfigurations(this.props.configurations);

    const setAddressPromise = availabilityApi
      .setMandiAddress(this.props.address, this.props.requiresConfirmation)
      .then((response) => {
        const { address, propertyId, customerId } = response.data.result;
        const {
          id, line1, line2, city, state, zipCode, newPropertyName,
        } = address;
        const addressToStore = {
          uuid: id,
          line1,
          line2,
          city,
          state,
          zipCode,
          normalizedBy: this.props.requiresConfirmation ? 0 : 1,
          existingAddress: this.props.existingAddress,
          requiresConfirmation: this.props.requiresConfirmation,
          newPropertyName,
        };
        localStorage.setItem(config.mandiAddressKey, JSON.stringify(addressToStore));
        document.cookie = `bookPage.verifiedAddress=${JSON.stringify(addressToStore)}; path=/; domain=${window.globals.designModeCookieDomain};`;

        return createMandIEstimate(
          id,
          propertyId,
          customerId,
          measureAndInstallEstimate,
          itemsWithExtraQuantity,
        );
      });

    Promise.all([configurationsPromise, setAddressPromise])
      .then(() => (window.location.href = config.mandiLandingPage))
      .then(tap(() => this.props.loaded()))
      .catch(err => this.props.globalError({ err }));
  };

  render() {
    return (
      <div className="covered-step">
        <div className="description">
          Good news! An installer with{' '}
          <strong>Home Depot's Authorized Service Provider Network</strong> is available in your
          area. Their work is licensed, insured, and background-checked. Get started today!
        </div>
        <div className="results">
          <strong>Showing Results For:</strong>
          {formatAddressForDisplay(this.props.address)}
        </div>
        {!this.props.allProductsEligible && (
          <div className="eligibility-note">
            <InfoFullIcon />
            <span className="text">
              <b>Note:</b> Shutters, outdoor shades and drapes are not eligible for professional
                measure and install.
            </span>
          </div>
        )}
        <div className="footer full-width">
          <button className="btn btn-primary full-width next-step-mandi" onClick={this.redirectMandI}>
            Next Step: Schedule Measure Appointment
          </button>
          <ContactFooter />
        </div>
      </div>
    );
  }
}

const windowPropType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  productName: PropTypes.string,
  autobahnEstimateGuid: PropTypes.string.isRequired,
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  productId: PropTypes.number,
});

const roomPropType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  windows: PropTypes.arrayOf(windowPropType),
});

CoveredByThd.propTypes = {
  address: PropTypes.shape({
    line1: PropTypes.string,
    line2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
  }).isRequired,
  requiresConfirmation: PropTypes.bool.isRequired,
  existingAddress: PropTypes.bool.isRequired,
  loading: PropTypes.func.isRequired,
  loaded: PropTypes.func.isRequired,
  globalError: PropTypes.func.isRequired,
  configurations: PropTypes.arrayOf(PropTypes.shape({
    configurationGuid: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
  })).isRequired,
  measureAndInstallEstimate: PropTypes.shape({
    name: PropTypes.string.isRequired,
    rooms: PropTypes.arrayOf(roomPropType),
  }).isRequired,
  allProductsEligible: PropTypes.bool.isRequired,
  itemsWithExtraQuantity: PropTypes.objectOf(PropTypes.number).isRequired,
};

export default CoveredByThd;
